import { makeModule } from "@/store/utils"
import { make } from "vuex-pathify"

const state = {
	loading: false,

    currentStep: 0,
    steps: [],

    approxDiameter: 1,
	minDiameter: 1,
	maxDiameter: 101,

	diameter: null,
    diameters: [],

	pitch: null,
	pitches: [],

	showResultModal: false,
	refs: [],
};

const getters = {
	...make.getters(state),
    activeSteps(state){
        return state.steps.filter((_, i) => i <= state.currentStep);
    },
	indexOfStep(state){
		return stepName => {
			return state.steps.indexOf(stepName);
		};
	},
	isLoading(state){
		return !!state.loading;
	}
};

const changeStuff = (mutAll, mut) => (state, payload) => {
	mutations[mutAll](state, payload);
	mutations[mut](state, null);
};

const mutations = {
	...make.mutations(state),
	START_LOADING(state){
		state.loading = true;
	},
	STOP_LOADING(state){
		state.loading = false;
	},
	CHANGE_DIAMETERS: changeStuff("SET_DIAMETERS", "SET_DIAMETER"),
  	CHANGE_PITCHES: changeStuff("SET_PITCHES", "SET_PITCH"),
	RESET_DIAMETER(state){
		state.diameter = null;
	},
	RESET_PITCH(state){
		state.pitch = null;
	},
	STEP_FORWARD(state){
		const max = state.steps.length - 1;
		if(state.currentStep > max){
			mutations.SET_CURRENT_STEP(state, max);
			return;
		}

		state.currentStep += 1;
	},
	STEP_BACKWARD(state){
		const min = 0;
		if(state.currentStep < min){
			mutations.SET_CURRENT_STEP(state, min);
			return;
		}

		state.currentStep -= 1;
	},
	CHANGE_INDEX(state, newIndex){
		if(0 > newIndex || newIndex > state.steps.length)
			return;

		mutations.SET_CURRENT_STEP(state, newIndex);
	},
	CLOSE_RESULT_MODAL(state){
		mutations.SET_SHOW_RESULT_MODAL(state, false);
	},
	OPEN_RESULT_MODAL(state){
		mutations.SET_SHOW_RESULT_MODAL(state, true);
	},
};

const actions = {
	...make.actions(state),
	CLOSE_RESULT_MODAL({ commit }){
		commit("CLOSE_RESULT_MODAL");
	},
};

export default makeModule({
    state,
    getters,
    mutations,
    actions,
})